<template>
  <el-dialog
    title="新建艺人"
    :visible="true"
    :close-on-click-modal="false"
    @close="handleCancel"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="80px">
      <el-form-item label="艺人名" prop="singerName">
        <el-input
          v-model="form.singerName"
          v-trans-complex="'艺人名'"
        ></el-input>
      </el-form-item>
      <el-form-item label="翻译名" prop="transName">
        <el-input v-model="form.transName"></el-input>
      </el-form-item>
      <el-form-item label="活跃地区" prop="area">
        <el-select v-model="form.area">
          <el-option
            v-for="(name, key) in areaMap"
            :data-key="key"
            :key="key"
            :label="name"
            :value="+key"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="类型" prop="type">
        <el-select v-model="form.type">
          <el-option
            v-for="(name, key) in actorTypeMap"
            :data-key="key"
            :key="key"
            :label="name"
            :value="+key"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="角色" prop="role">
        <el-select v-model="form.role" multiple>
          <el-option
            v-for="(name, key) in roleMap"
            :data-key="key"
            :key="key"
            :label="name"
            :value="+key"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="一级流派" prop="genre">
        <el-select
          v-model="form.genre"
          placeholder="选择流派"
          class="form-field"
          @change="form.subGenre = ''"
        >
          <el-option
            v-for="(name, id) in genreMap"
            :key="id"
            :label="`${id}. ${name}`"
            :value="id"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        v-if="checkShowSubGenre"
        label="二级流派"
        prop="subGenre"
      >
        <el-select
          placeholder="选择流派"
          v-model="form.subGenre"
          class="form-field"
          filterable
        >
          <template
            v-for="(name, id) in subGenreMap"
          >
            <el-option
              v-if="checkSubGenre(+id)"
              :key="id"
              :label="`${id}. ${name}`"
              :value="id"
            ></el-option>
          </template>
        </el-select>
      </el-form-item>

      <el-form-item label="简介" prop="singerDesc">
        <el-input
          type="textarea"
          v-trans-complex="'简介'"
          v-model="form.singerDesc"
          placeholder="不超过250个字"
        ></el-input>
      </el-form-item>
      <el-form-item label="封面图" prop="singerPhotoList">
        <el-upload
          action="/action/upload?type=image"
          multiple
          :on-error="hndleError"
          :on-success="handleSuccess"
          :before-upload="handleBeforeUpload"
          :accept="`.${imageType.join(',.')}`"
          :show-file-list="false"
        >
          <!-- <i class="el-icon-plus"/> -->
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">请上传分辨率为1080*1080以上的jpg/png文件</div>
        </el-upload>
        <draggable v-model="form.singerPhotoList" class="preview-block">
          <div v-for="(file, index) in form.singerPhotoList" :key="file.url" class="preview-pic">
            <img :src="file.url" class="pic" @click="handlePreview(file.url)">
            <span class="index">{{ index }}</span>
            <i class="el-icon-delete delete" @click="handleRemove(index)" />
          </div>
        </draggable>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button type="ghost" @click="handleCancel">取 消</el-button>
      <el-button type="primary" @click="handleCreateActor" :loading="submiting">提 交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import draggable from 'vuedraggable'
import {
  actorTypeMap,
  imageType,
  areaMap,
  roleMap,
  genreMap,
  subGenreMap,
  hasSubGenreSet
} from './mixin.js'
import actorService from '@/api/actor'
import { STATUS_CODE } from '@/utils/constants'
import { validateFileExt } from '@/utils/validate'

export default {
  name: 'SingerEdit',
  components: {
    draggable
  },
  data() {
    return {
      actorTypeMap,
      imageType,
      areaMap,
      roleMap,
      genreMap,
      subGenreMap,
      form: {
        singerName: '',
        transName: '',
        area: 0,
        type: 0,
        singerDesc: '',
        singerPhotoList: [],
        role: [],
        genre: '',
        subGenre: ''
      },
      rules: {
        singerName: [
          { required: true, message: '请输入艺人名', trigger: 'blur' }
        ],
        area: [
          { required: true, message: '请选择活跃地区', trigger: 'change' }
        ],
        type: [
          { required: true, message: '请选择类型', trigger: 'change' }
        ],
        singerDesc: [
          { required: true, message: '请输入艺人简介', trigger: 'blur' }
        ],
        singerPhotoList: [
          { type: 'array', required: true, message: '请上传艺人图', trigger: 'change' }
        ],
        role: [
          { type: 'array', required: true, message: '请选择艺人角色', trigger: 'change' }
        ],
        genre: [
          { required: true, message: '请填写一级流派', trigger: 'change' }
        ],
        subGenre: [
          { required: true, message: '请填写二级流派', trigger: 'change' }
        ],
      },
      uploading: false,
      submiting: false
    }
  },
  computed: {
    /**
     * @returns {Boolean}
     */
    checkShowSubGenre() {
      return hasSubGenreSet.has(+this.form.genre)
    },
  },
  methods: {
    hndleError(err, file, fileList) {
      this.uploading = false
      this.$message.error('上传失败: ' + err.message)
    },

    checkSubGenre(val) {
      return this.form.genre === `${Math.floor(val / 100)}`
    },

    handleBeforeUpload(file) {
      if (!validateFileExt(imageType, file.name)) {
        this.$message.warning('不支持的文件类型')
        return false
      }
      return true
    },

    handleSuccess(resp, file, fileList) {
      if (resp.code === STATUS_CODE.SUCCESS) {
        const respData = resp.data
        const fileData = {
          url: this.$toPreview(respData.url),
          photoPath: respData.file_id,
          photoUrl: respData.url,
          photoSize: respData.size,
          photoHeight: respData.file_info.height,
          photoWidth: respData.file_info.width,
          md5: respData.md5,
          qUrl: '',
          qCfs: '',
          using: 1
        }
        this.form.singerPhotoList.push(fileData)

        this.uploading = false
      } else {
        this.$message.error('上传异常: ' + resp.msg)
      }
    },

    handleRemove(index) {
      this.form.singerPhotoList.splice(index, 1)
    },

    handlePreview(url) {
      open(url, '_blank')
    },

    handleCancel() {
      this.$emit('cancel')
    },

    async handleCreateActor() {
      const postData = {
        ...this.form
      }
      postData.role = postData.role.join(',')
      try {
        await this.$refs.form.validate()

        const checkResult = this.checkSingerName(postData)
        if (checkResult.then) {
          await checkResult
        }
      } catch (error) {
        return
      }
      await this.$confirm('提交后无法修改，请确保所有信息填写正确！', '提示', {
        confirmButtonText: '提 交',
        cancelButtonText: '取 消',
        type: 'warning'
      })
      this.saveActor(postData)
    },

    /**
     * @see http://tapd.oa.com/tme_music_lib/prong/stories/view/1020369272856960739
     */
    checkSingerName(singerData) {
      const { singerName, area, transName, type } = singerData
      const repeatSymbols = ['and', 'feat', 'featuring', 'present', 'meet', 'vs', '\\']
      const roleError = ['瑜伽', '健身', '冥想', '婴儿', '圣诞节', '热门歌曲']
      const questError = ['?', '？']
      let msg = ''

      // 欧美艺人英文逗号规则
      if (area === 3 && singerName.indexOf(',') >= 0) {
        msg = '<div>艺人名字段存在 <span class="danger-word">,</span> 字符，请确认是否提交</div>'
      } else if (/[|,，、/;；&]/g.test(singerName) || repeatSymbols.some(item => singerName.includes(item))) {
        // 疑似重复
        msg = '<div>艺人名字段疑似多个艺人，请确认是否提交</div>'
      } else if (questError.some(item => singerName.includes(item))) {
        msg = '<div>请注意不要提交乱码内容，若官方要求如此，请继续</div>'
      } else if ((type !== 3) && roleError.some(item => singerName.includes(item))) {
        // 类型错误
        msg = '<div>艺人类型疑似错误，请确认是否提交</div>'
      } else if (transName.includes(singerName)) {
        // 翻译名包含艺人名
        msg = '<div>艺人翻译名包含艺人名信息，请确认是否提交</div>'
      }

      if (msg) {
        return this.$confirm(msg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          dangerouslyUseHTMLString: true,
          type: 'warning'
        })
      } else {
        return true
      }
    },

    saveActor(postData) {
      actorService.save(postData).then(resp => {
        this.$emit('cancel', false)
        this.$emit('search', postData.singerName)
      }).catch(error => {
        this.$message({
          type: 'error',
          message: `新建异常：${error.message}`
        })
      }).finally(_ => {
        this.submiting = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.preview-block {
  display: flex;
  background-color: #f3f3f3;
  padding: 0 8px 8px 0;
}
.preview-pic {
  position: relative;
  width: 100px;
  height: 100px;
  margin: 8px 0 0 8px;
  outline: 1px solid #ccc;
  cursor: move;

  &:hover {
    .delete {
      display: block;
    }
  }

  .pic {
    width: 100px;
    height: 100px;
  }

  .index {
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 20px;
    height: 20px;
    line-height: 20px;
    border-radius: 20px;
    text-align: center;
    background-color: rgb(52, 137, 248);
    color: #fff;
  }

  .delete {
    display: none;
    position: absolute;
    top: 1px;
    right: 1px;
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    border: none;
    cursor: pointer;
    color: red;
    background-color: #fff;

    // &:hover {
    //   color: red;
    // }
  }
}
</style>
